import { useDraftStore } from '@/lib/draftStore';
import { PhotoPicker } from '../PhotoPicker';
import { FormField } from '@/components/ui/FormField';
import type { UploadedPhoto } from '@/types/domain';

export const Step1Photos = () => {
  const photos = useDraftStore((s) => s.draft.photos);
  const update = useDraftStore((s) => s.update);

  return (
    <FormField
      label="Фотографии"
      hint={`До 8 фото · первое будет обложкой · ${photos.length} / 8`}
      required
    >
      <PhotoPicker photos={photos} onChange={(p) => update({ photos: p })} />
    </FormField>
  );
};

export const validateStep1 = (draft: { photos: UploadedPhoto[] }): string | null => {
  if (draft.photos.length === 0) return 'Добавь хотя бы одно фото';
  return null;
};